<template>
  <chart-shell title="体位" info="">
    <div>
      <div
        class="position-chart"
        :style="{ height: `${height}px` }"
        id="体位"
      ></div>
    </div>
  </chart-shell>
</template>

<script>
import ChartShell from "@c/report-detail/sleep-chart/chart-shell.vue";
import { Line } from "@antv/g2plot";

const POSITION_LABELS = ["Unsure", "Prone", "Supine", "Left", "Right"];

export default {
  components: { ChartShell },

  props: {
    timeTickArray: Array,
    height: {
      type: Number,
      default: 120,
    },
  },

  mounted() {
    this.renderChart();
  },

  methods: {
    renderChart() {
      const ticks = this.timeTickArray || [];
      // 用首尾 tick 建立 x 轴域，yValue 为 null 不绘制折线
      const data =
        ticks.length >= 2
          ? [
              { xValue: ticks[0], yValue: null },
              { xValue: ticks[ticks.length - 1], yValue: null },
            ]
          : [];

      const chart = new Line("体位", {
        data,
        xField: "xValue",
        yField: "yValue",
        meta: {
          xValue: {
            type: "time",
            alias: "时间",
            mask: "HH:mm",
            tickMethod: () => ticks,
          },
        },
        xAxis: {
          line: { style: { stroke: "#333" } },
          tickLine: { style: { stroke: "#333" } },
        },
        yAxis: {
          min: 0,
          max: 4,
          tickCount: 5,
          label: {
            formatter: (val) => POSITION_LABELS[parseInt(val)] ?? val,
          },
          grid: null,
          line: { style: { stroke: "#333" } },
          tickLine: { style: { stroke: "#333" } },
        },
        lineStyle: { lineWidth: 0 },
        tooltip: { showContent: false },
        legend: false,
      });
      chart.render();
    },
  },
};
</script>

<style lang="scss" scoped>
.position-chart {
  width: 100%;
  box-sizing: border-box;
  padding: 0 rem(25);
  margin-top: rem(10);
  margin-bottom: rem(10);
}
</style>
